import React from 'react';

/**
 * AdminMobileMenu Component
 *
 * Mobile dropdown menu for navigation
 * Extracted from AdminDashboard header to reduce file size
 */
const AdminMobileMenu = ({
  isOpen,
  onClose,
  activeTab,
  setActiveTab,
  adminName,
  onLogout
}) => {
  if (!isOpen) return null;

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    onClose();
  };

  return (
    <nav className="lg:hidden border-t pb-4 pt-4 max-h-96 overflow-y-auto bg-white">
      <div className="space-y-1 px-4">
        {/* Overview */}
        <button
          onClick={() => handleTabChange('overview')}
          className={`w-full text-left px-4 py-3 rounded-md text-sm hover:bg-gray-100 ${
            activeTab === 'overview' ? 'bg-blue-50 text-blue-700' : ''
          }`}
        >
          Overview
        </button>

        {/* Calendar Section */}
        <div className="border-t pt-2 mt-2">
          <p className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">
            Calendar
          </p>
          <button
            onClick={() => handleTabChange('calendar')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'calendar' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Room Calendar
          </button>
          <button
            onClick={() => handleTabChange('car-calendar')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'car-calendar' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Car Calendar
          </button>
        </div>

        {/* My Property Section */}
        <div className="border-t pt-2 mt-2">
          <p className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">
            My Property
          </p>
          <button
            onClick={() => handleTabChange('room-types')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'room-types' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Room Types
          </button>
          <button
            onClick={() => handleTabChange('rooms')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'rooms' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Rooms
          </button>
          <button
            onClick={() => handleTabChange('rates')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'rates' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Rates
          </button>
          <button
            onClick={() => handleTabChange('room-closures')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'room-closures' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Room Closures
          </button>
          <button
            onClick={() => handleTabChange('car-types')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'car-types' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Car Types
          </button>
          <button
            onClick={() => handleTabChange('cars')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'cars' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Cars
          </button>
          <button
            onClick={() => handleTabChange('car-rates')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'car-rates' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Car Rates
          </button>
          <button
            onClick={() => handleTabChange('transfers')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'transfers' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Transfers
          </button>
          <button
            onClick={() => handleTabChange('terms')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'terms' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Terms & Conditions
          </button>
        </div>

        {/* Bookings Section */}
        <div className="border-t pt-2 mt-2">
          <p className="px-4 py-2 text-xs font-semibold text-gray-500 uppercase">
            Bookings
          </p>
          <button
            onClick={() => handleTabChange('bookings')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'bookings' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            List View
          </button>
          <button
            onClick={() => handleTabChange('customers')}
            className={`w-full text-left px-4 py-2 rounded-md text-sm hover:bg-gray-100 ${
              activeTab === 'customers' ? 'bg-blue-50 text-blue-700' : ''
            }`}
          >
            Customers
          </button>
        </div>

        {/* Payments */}
        <button
          onClick={() => handleTabChange('payments')}
          className={`w-full text-left px-4 py-3 rounded-md text-sm hover:bg-gray-100 border-t mt-2 pt-4 ${
            activeTab === 'payments' ? 'bg-blue-50 text-blue-700' : ''
          }`}
        >
          Payments
        </button>

        {/* Audit */}
        <button
          onClick={() => handleTabChange('audit')}
          className={`w-full text-left px-4 py-3 rounded-md text-sm hover:bg-gray-100 ${
            activeTab === 'audit' ? 'bg-blue-50 text-blue-700' : ''
          }`}
        >
          Audit
        </button>

        {/* Settings */}
        <button
          onClick={() => handleTabChange('settings')}
          className={`w-full text-left px-4 py-3 rounded-md text-sm hover:bg-gray-100 ${
            activeTab === 'settings' ? 'bg-blue-50 text-blue-700' : ''
          }`}
        >
          Settings
        </button>
      </div>
    </nav>
  );
};

export default AdminMobileMenu;
